<template>

    <div>
        <form class="needs-validation" novalidate>
            <!-- ***** start custom content ***** -->
            <h1>{{$t('voter_list')}}</h1>

            <h2>{{$t('step_1_eligibility')}}</h2>

            <div class="callout callout-warning">
                <p>{{$t('step_1_eligibility_note')}}</p>
                <ul>
                    <li>{{$t('step_1_eligibility_note_1')}}</li>
                    <li>{{$t('step_1_eligibility_note_2')}}</li>
                    <li>{{$t('step_1_eligibility_note_3')}}</li>
                </ul>
            </div>
            <fieldset>
                <legend>{{$t('step_1_eligibility_confirm')}}</legend>
                <div class="custom-control custom-checkbox mb-2">
                    <input type="checkbox" class="custom-control-input" id="customCheck1" value="Yes" v-model="canadian" required>
                    <label class="custom-control-label font-weight-normal" for="customCheck1">{{$t('step_1_eligibility_confirm_1')}}</label>
                </div>
                <div class="custom-control custom-checkbox mb-2">
                    <input type="checkbox" class="form-control custom-control-input" id="customCheck2" value="Yes" v-model="at_least_18" required>
                    <label class="custom-control-label font-weight-normal" for="customCheck2">{{$t('step_1_eligibility_confirm_2')}}</label>
                </div>
                <div class="custom-control custom-checkbox mb-2">
                    <input type="checkbox" class="form-control custom-control-input" id="customCheck3" value="Yes" v-model="resident" required>
                    <label class="custom-control-label font-weight-normal" for="customCheck3">{{$t('step_1_eligibility_confirm_3')}}</label>
                </div>
                <div class="invalid-feedback" v-if="!valid_register">{{$t('step_1_eligibility_error')}}</div>
            </fieldset>


            <div class="row no-gutters">
                <div class="col">
                    <button class="btn btn-secondary mt-4 float-right" @click="next_step">{{$t('next')}}</button>
                </div>
            </div>

            <!-- ***** end custom content ***** -->
        </form>

    </div>
</template>
<style scoped>
    .invalid {
        width: 100%;
        margin-top: .25rem;
        font-size: 1rem;
        color: #CE2334;
    }
</style>
<script>
    import $ from "jquery";

    export default{
        data() {
            return {
                canadian: null,
                at_least_18: null,
                resident: null,
                page_type: null,
                voter: [],
            }
        },
        created: function () {
            this.voter = this.$store.getters.VOTER;

            this.page_type = this.$route.params.page_type;

            if (this.voter.length > 0) {
                let info = this.voter[0];

                this.canadian = info.canadian;
                this.at_least_18 = info.at_least_18;
                this.resident = info.resident;
            }
        },
        methods: {
            next_step: function () {
                //bus.$emit('change-tab', tran('register_vote_two'));
                // Fetch all the forms we want to apply custom Bootstrap validation styles to
                var forms = document.getElementsByClassName('needs-validation');
                // Loop over them and prevent submission
                var validation = false;

                Array.prototype.filter.call(forms, function (form) {
                    validation = form.checkValidity();

                    if (form.checkValidity() === false) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    form.classList.add('was-validated');
                    
                    $(".invalid-feedback").removeClass("invalid-feedback").addClass("invalid");
                });
                
                if (validation === true) {
                    var voter = {
                        canadian: this.canadian,
                        at_least_18: this.at_least_18,
                        resident: this.resident,
                        page_type: this.page_type
                    };
                    //this.$store.commit('update_voter', voter);
                    this.$store.dispatch("SAVE_VOTER", voter);

                    this.$router.push({ name: "Step2", params: { page_type: this.$route.params.page_type, voter_id: this.$route.params.voter_id } });
                }
            },
            cancel: function () {
                window.location = "default.stm";
            }
        },

        computed: {
            valid_canadian: function () {
                return (this.canadian === 'Yes');
            },
            valid_age: function () {
                return (this.at_least_18 === 'Yes');
            },
            valid_resident: function () {
                return (this.resident === 'Yes');
            },
            valid_register: function () {
                return (this.valid_age && this.valid_canadian && this.valid_resident);
            },
            empty_form: function () {
                return (this.canadian == null || this.at_least_18 == null || this.resident == null);
            },
            disabled_button: function () {
                return (!this.valid_register);
            }
        },
    }

    //window.addEventListener("load", function () {
    //    let title = $("h1").text();
        
    //    if (title !== "Check the voters list") {
    //        $("li.breadcrumb-item").text(function () {
    //            return $(this).text().replace("Check the voters list", "Voter registration");
    //        });
    //    }
    //});
</script>